import axios from "axios";
import store from "@/state/store";

const BACKEND_URL = process.env.VUE_APP_BACKEND_URL;

let isRefreshing = false;
let failedQueue = [];

// procesa lista de solicitudes que fallaron mientras se esperaba la renovación del token
const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
      if (error) {
        prom.reject(error);
      } else {
        prom.resolve(token);
      }
    });
  
    failedQueue = [];
};


const instance = axios.create({
    baseURL: BACKEND_URL,
    headers: {
      'Content-Type': 'application/json',
    },
});

// Interceptor de solicitud
instance.interceptors.request.use(
    (config) => {
      const token = sessionStorage.getItem('idToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
);

// Interceptor de respuesta
instance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const originalRequest = error.config;

      if (error.response && error.response.status === 401 && !sessionStorage.getItem("idToken")) {
        return Promise.reject(error);
      }
  
      if (error.response && error.response.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise(function(resolve, reject) {
            failedQueue.push({ resolve, reject });
          }).then(token => {
            originalRequest.headers['Authorization'] = 'Bearer ' + token;
            return axios(originalRequest);
          }).catch(err => {
            return Promise.reject(err);
          });
        }
  
        originalRequest._retry = true;
        isRefreshing = true;
  
        const refreshToken = sessionStorage.getItem('refreshToken');
  
        return new Promise(function (resolve, reject) {
          store.dispatch("auth/callRefreshToken", refreshToken)
            .then((newToken) => {
              sessionStorage.setItem('idToken', newToken);
              instance.defaults.headers['Authorization'] = 'Bearer ' + newToken;
              originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
              processQueue(null, newToken);
              resolve(axios(originalRequest));
            })
            .catch((err) => {
              processQueue(err, null);
              store.dispatch("auth/logoutAction");
              reject(err);
            })
            .finally(() => {
              isRefreshing = false;
            });
        });
      }
  
      return Promise.reject(error);
    }
);
  
export default instance;